'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dompurify = require('dompurify');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _Spinner = require('../loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

require('./ElementIcon.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


// Styles


var cleanSVGIcon = function cleanSVGIcon(svg) {
    return { __html: (0, _dompurify.sanitize)(atob(svg)) };
};

var SVGIcon = function SVGIcon(_ref) {
    var svg = _ref.svg,
        className = _ref.className;
    return _react2.default.createElement('div', { className: (0, _classnames2.default)('Icon SVGIcon', className), dangerouslySetInnerHTML: cleanSVGIcon(svg) });
};

SVGIcon.propTypes = {
    svg: _propTypes2.default.string,
    className: _propTypes2.default.string
};

var StringIcon = function StringIcon(_ref2) {
    var string = _ref2.string,
        className = _ref2.className;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Icon StringIcon', className) },
        _react2.default.createElement(
            'div',
            { className: 'string-icon-' + string.length },
            string.split('').map(function (letter, i) {
                return _react2.default.createElement(
                    'span',
                    { key: i },
                    letter
                );
            })
        )
    );
};

StringIcon.propTypes = {
    string: _propTypes2.default.string,
    className: _propTypes2.default.string
};

var ElementIcon = function (_React$Component) {
    _inherits(ElementIcon, _React$Component);

    function ElementIcon() {
        _classCallCheck(this, ElementIcon);

        var _this = _possibleConstructorReturn(this, (ElementIcon.__proto__ || Object.getPrototypeOf(ElementIcon)).call(this));

        _this.state = {
            faded: false
        };

        _this.fadeTimerId = null;
        return _this;
    }

    _createClass(ElementIcon, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var icon = this.props.icon;

            this.setState({ icon: icon });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var currentlyShowingSpinner = this.props.showLoading && this.props.icon && this.props.icon.get('fetching');
            var nextShowingSpinner = nextProps.showLoading && nextProps.icon && nextProps.icon.get('fetching');

            if (currentlyShowingSpinner && !nextShowingSpinner) {
                // Start as faded
                this.setState({ faded: true });
                // The next frame remove the faded flag and allow the CSS transition to occur
                requestAnimationFrame(function () {
                    return _this2.setState({ faded: false });
                });
            }

            if (nextProps.icon !== this.props.icon) {
                this.setState({ faded: true });

                // If we shouldn't fade, just return to the non-faded state and change the icon immediately
                var timerDelay = nextProps.enableFade ? 300 : 0;
                // The next frame remove the faded flag and allow the CSS transition to occur
                this.fadeTimerId = (0, _lodash.delay)(function () {
                    return _this2.setState({ icon: nextProps.icon, faded: false });
                }, timerDelay);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.fadeTimerId && clearTimeout(this.fadeTimerId);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                showLoading = _props.showLoading,
                enableFade = _props.enableFade;
            var _state = this.state,
                icon = _state.icon,
                faded = _state.faded;


            var svg = icon && icon.get('svg');
            var string = icon && icon.get('string');

            if (icon && showLoading && icon.get('fetching')) return _react2.default.createElement(_Spinner2.default, { show: true });
            if (icon && svg) return _react2.default.createElement(SVGIcon, { className: (0, _classnames2.default)({ faded: faded && !enableFade }), svg: svg });
            if (icon && string) {
                return _react2.default.createElement(StringIcon, { className: (0, _classnames2.default)({ faded: faded && !enableFade }), string: string });
            }
            return null;
        }
    }]);

    return ElementIcon;
}(_react2.default.Component);

ElementIcon.propTypes = {
    icon: _propTypes2.default.object,
    showLoading: _propTypes2.default.bool,
    enableFade: _propTypes2.default.bool
};

exports.default = function (props) {
    return _react2.default.createElement(
        'div',
        { className: 'ElementIcon' },
        _react2.default.createElement(ElementIcon, props)
    );
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/elementIcon/ElementIcon.js
// module id = 428
// module chunks = 0